import { domainRegex } from './regex';
import { NajizToaster } from '@moj/najiz-toastify';
import { HandledServerErrorsStatuses } from '@/services/constants';
import { errorToasterConfigs } from '@/configs/toaster';

const whitelistedDomains = [
  'merath.najiz.sa',
  'taswya.najiz.sa',
];

export const getUrlWithNajizDomain = (url: string) => {
  const isNajizDomain = url.includes('najiz');
  const isWhitelisted = whitelistedDomains.some((domain) => url.includes(domain));

  return isNajizDomain && !isWhitelisted ? url.replace(domainRegex, location.origin) : url;
};

export const isEmptyObject = (obj: any): boolean => {
  if (obj === null) {
    return false;
  }

  return Object.keys(obj).length === 0;
};

export const getTotalHeight = (element: HTMLElement | null): number => {
  if (!element) {
    return 0;
  }

  const styles = window.getComputedStyle(element);
  const marginTop = parseFloat(styles.marginTop);
  const marginBottom = parseFloat(styles.marginBottom);
  // ? including paddings
  const elementHeight = element.offsetHeight;

  return elementHeight + marginTop + marginBottom;
};

export const getDirectionMeta = () => {
  const language = (document.getElementById('lang_placeholder') as HTMLInputElement)?.value || 'ar';

  return {
    language,
    isRTL: language === 'ar',
  };
};

export const handleErrors = (httpCode: number, errors: string[], fallbackMessage = '') => {
  if (!HandledServerErrorsStatuses.includes(httpCode)) {
    if (errors && Array.isArray(errors) && errors.length) {
      errors.forEach((message: string) => NajizToaster.error({
        message,
        ...errorToasterConfigs,
      }));
    } else if (fallbackMessage) {
      NajizToaster.error({
        message: fallbackMessage,
        ...errorToasterConfigs,
      });
    }
  }
};

export const normalizeArabic = (text: string): string => {
  if (!text) return '';

  return text
    .replace(/[إأآٱ]/g, 'ا')
    .trim();
};
